import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M5.5 20.5C4.94772 20.5 4.5 20.0523 4.5 19.5V4.49999C4.5 3.9477 4.94772 3.49996 5.5 3.49996H11.88C12.2602 3.49734 12.6089 3.71048 12.78 4.04999L13.5 5.49999H18.5C19.0523 5.49999 19.5 5.9477 19.5 6.49999V14.5C19.5 15.0523 19.0523 15.5 18.5 15.5H13.11C12.7334 15.4988 12.3895 15.2863 12.22 14.95L11.5 13.5H6.5V19.5C6.5 20.0523 6.05228 20.5 5.5 20.5ZM6.5 5.49999V11.5H12.5L13.5 13.5H17.5V7.49999H12.5L11.5 5.49999H6.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "FlagOutline"
);
